import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Copyright } from "./components/shared";
import { DisplayMode, GameMode, ErrorPage, PlayMode } from "./containers";
import styles from "./styles/App.module.scss";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <div className={styles.App}>
        <Routes>
          <Route path="/game" element={<GameMode />} />
          <Route path="/play" element={<PlayMode />} />
          <Route path="/" element={<DisplayMode />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
      <Copyright />
    </BrowserRouter>
  );
};

export default App;
